import React, {Component} from 'react';
import { connect} from 'react-redux'
import {bindActionCreators, compose} from 'redux'
import CTable from '@/components/CTable'
import CButton from '@/components/CButton'
import CBaseComponent from '@/components/CBaseComponent'
import { setReload } from "@/redux/common/action";
import { tableData} from './data'
import './index.scss'
import { getpfcxdetail } from "@/servers/goodsManageApi";
import {withRouter} from "react-router-dom";
import {getStorage} from "@/utils";

@CBaseComponent
class GoodsManageList extends Component{
  constructor(props) {
    super(props);
    this.getListData = this.getListData.bind(this);
    this.editHandler = this.editHandler.bind(this);
    this.onChange = this.onChange.bind(this)
    this.onTableChange = this.onTableChange.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    // reload时重新加载数据
    // this.getListData();
  }


  state = {
    columns: tableData.tHead,
    dataSource: tableData.tBody,
    dataSourceall: [],
    page: tableData.tPage,
    loading: true,
  };


  onTableChange(data){
    let d =this.state.dataSourceall
    var bIndex = parseInt(data.data.pageSize) * (parseInt(data.data.page) - 1);
    var eIndex = parseInt(bIndex) + parseInt(data.data.pageSize);
    var newDataList = [];
    for(var i = bIndex;i < eIndex;i++){
      if (d[i]) {
        newDataList.push(d[i]);
      }
    }
    this.setState({
      page: {...this.state.page, ...data.data},
      dataSource:newDataList
    })
  }


  // 获取用户列表数据
  getListData(){
    const data = getStorage('userList')
    let getData = {
      miid: data.miid
    };
    this.setState({
      loading: true
    });
    getpfcxdetail(getData).then(res=>{
      let d = JSON.parse(JSON.stringify(res.records))
      let  data = d.splice((this.state.page.page-1)*this.state.page.pageSize,this.state.page.page*this.state.page.pageSize)
      this.setState({
        dataSource: data,
        dataSourceall:res.records,
        page: {...this.state.page, total:res.records.length},
        loading: false,
      });
    }).catch(err=>{
      console.log(err,'rttt')
    })
  }

  onChange(data){
    this.setState({
      provinceid:data
    },()=>{
      this.getListData()
    })
  }

  // 编辑当前行
  editHandler(data){
    sessionStorage.setItem('libraryuser', JSON.stringify(data))
    this.props.history.push({
      pathname: '/addlibraryUser',
      search: `?type=edit&id=${data.id}`
    })
  }
  componentWillMount(){

  }

  componentDidMount(){
    this.getListData();
  }
  render(){
    return (
        <div className='user-manage-list'>
          <CTable ref='userManageList' checked={false} loading={this.state.loading} columns={this.state.columns} dataSource={this.state.dataSource}
                  page={this.state.page}
                  onTableChange={this.onTableChange}
          >
            <div
                slot='index'
                render={(text, record, index) => (
                    <div className='operate'>
                      {index+1}
                    </div>
                )} />
            <div
                slot='operate1'
                render={(text, record, index) => (
                    <div className='operate'>
                      <CButton type='text' authId='goodsManageListEdit' onClick={() => this.editHandler(record)}>编辑</CButton>
                    </div>
                )} />
          </CTable>
        </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    reload: state.reload,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setReload: bindActionCreators(setReload, dispatch)
  }
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(GoodsManageList);
